import { usePermissionGuard } from "./permissionGuard";
import { useChunkGuard } from "./chunkGuard";

export function useGuard(router) {
  usePermissionGuard(router);
  useChunkGuard(router);
}
